import { Box, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CustomTypography from "../../../Typography";
import muiCustomStyles from "../styles/styles";
import CustomTooltipBox from "../../../CustomTooltips/CustomTooltipBox";

const ModalHeader = (props) => {
  const {
    dialogTitle,
    onClose,
    showHelpIcon = false,
    tooltipSectionsContent,
  } = props;

  const handleCancel = () => {
    onClose();
  };

  const { headerBoxStyle } = muiCustomStyles;
  return (
    <Box display="flex" alignItems="center" sx={headerBoxStyle}>
      <Box
        alignItems="center"
        gap="12px"
        sx={{ display: { xs: "none", sm: "flex" } }}
      >
        <CustomTypography
          type="subheading"
          props={{
            color: "rgba(62, 63, 76, 1)",
            lineHeight: "38px",
          }}
        >
          {dialogTitle}
        </CustomTypography>
      </Box>

      <Box
        display="flex"
        alignItems="center"
        sx={{ mr: { xs: "0px", sm: "-10px" } }}
      >
        {showHelpIcon ? (
          <Box sx={{ display: { xs: "none", sm: "flex" } }}>
            <CustomTooltipBox sections={tooltipSectionsContent} />
          </Box>
        ) : (
          <></>
        )}

        <IconButton onClick={handleCancel}>
          <CloseIcon
            sx={{
              color: {
                xs: "rgba(255, 255, 255, 1)",
                sm: "rgba(68, 65, 81, 1)",
              },
              fontSize: "28px",
            }}
          />
        </IconButton>
      </Box>
    </Box>
  );
};

export default ModalHeader;
